import React, { useEffect } from 'react';
import InfoBox, { InfoBoxType } from 'flow/components/ui-components/InfoBox';
import Page from 'flow/components/Setting/Page';
import useAppContext from 'flow/hooks/useAppContext';

/**
 * This component is used in the OAuth and OpenID Connect flows in the Electron app.
 *
 * In the web application the sign-in process is handled in a pop-up window, which sends a JS window
 * message to the main window that triggers a UI update when finished.
 *
 * In the Electron app, the sign-in process takes place in a system browser window and ends up at this component. Older
 * versions of the Electron app depend on a request being sent from the browser to local port 8087, so we do that here
 * to ensure that these old versions still work.
 */

const SocialIntegrationOauthLanding = () => {
    const { i18next } = useAppContext();

    useEffect(() => {
        const language = window.navigator.language
            ? window.navigator.language.split('-')[0]
            : 'en';
        i18next.changeLanguage(language);

        const params = new URL(window.location.href).searchParams;
        const token = params.get('token');
        const hasError = params.get('externalAuthError');

        if (!token && !hasError) {
            // This is for the OAuth flow. Just signal to the app that it should update
            sendRequestToApp({ method: 'GET' });
        } else {
            // This is the OpenID Connect flow. Forward the ID token (if present) to the app
            sendRequestToApp({ method: 'POST', body: token });
        }
    }, []);

    const sendRequestToApp = (requestOptions: RequestInit) => {
        fetch('http://localhost:8087', requestOptions).catch(() => {
            // Ignore errors
        });
    };

    return (
        <Page header="" discardHeader={true}>
            <div className="mt-10" />
            <InfoBox type={InfoBoxType.Info}>
                {i18next.t('oauth.landing.text')}
            </InfoBox>
        </Page>
    );
};

export default SocialIntegrationOauthLanding;
